import { Component, inject, Input, OnInit } from '@angular/core'
import { orangeDarkBg, orangeLightBg } from '../../../assets/designTokens/customTokens'
import { ButtonModule } from 'primeng/button'
import { SharedContent } from '../../services/shared-content/shared-content'
import { PhoneFormatPipe } from '../../pipes/phone-format-pipe'

@Component({
	selector: 'app-call-us-button',
	imports: [ButtonModule, PhoneFormatPipe],
	templateUrl: './call-us-button.html',
	styleUrl: './call-us-button.css',
})
export class CallUsButton implements OnInit {
	@Input() bgColor!: string
	@Input() fluid = true
	@Input() size!: any
	
	private sharedContent = inject(SharedContent)
	phoneNumber = this.sharedContent.phoneNumber

	designToken!: any

	ngOnInit(): void {		
		if (this.bgColor === 'light') {
			this.designToken = orangeLightBg
		}

		if (this.bgColor === 'dark') {
			this.designToken = orangeDarkBg
		}
	}
}
